export enum OENNotificationType {
  // Errors
  ERROR_MODIFY_OUT_PERMISSIONS,
  ERROR_MODIFY_OUT_EDIT,
  ERROR_MODIFY_OUT_SERVER_FAIL,
  // modify info
  ERROR_MODIFY_INFO_ACTIONED,
  ERROR_MODIFY_INFO_EXPIRED,
}
